import React from 'react';
import { Icon, Dicon } from 'edcom-ui';
import styles from './Bottom.module.less';

export default function Bottom() {
  return (
    <div className={styles.container}>
      <div className={styles.socialWrapper}>
        <a
          href="https://www.facebook.com/Education.comFanPage"
          title="Facebook"
          rel="noopener"
          className={styles.social}
        >
          <Icon name="facebook" />
        </a>
        <a
          href="https://twitter.com/education_com"
          title="Twitter"
          rel="noopener"
          className={styles.social}
        >
          <Icon name="twitter" />
        </a>
        <a
          href="https://www.youtube.com/user/brainzyxeducationcom"
          title="YouTube"
          rel="noopener"
          className={styles.social}
        >
          <Icon name="youtube" />
        </a>
        <a
          href="https://www.pinterest.com/education_com/"
          title="Pinterest"
          rel="noopener"
          className={styles.social}
        >
          <Icon name="pinterest" />
        </a>
      </div>
      <div className={styles.copyright}>
        Copyright © {new Date().getFullYear()} Education.com, Inc, a division of
        IXL Learning • All Rights Reserved.
        <div>
          <a href="https://www.ixl.com/" rel="nofollow" aria-label="ixl">
            <Dicon name="ixl-logo" className={styles.ixl} />
          </a>
        </div>
        <div>
          <a href="https://www.kidsafeseal.com/certifiedproducts/education.html" target="_blank" rel="noopener noreferrer">
            <img border="0" alt="Education.com is certified by the kidSAFE Seal Program." src="https://www.kidsafeseal.com/sealimage/50473324616348843/education_small_whitetm.png"/>
          </a>
        </div>
      </div>
    </div>
  );
}
